import React, { useState, useEffect } from 'react';
import './BookMeeting.css';
import { Link } from 'react-router-dom';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { FaMicrophoneAlt, FaMicrophoneAltSlash } from "react-icons/fa";
import { MdClear } from "react-icons/md";


const BookMeeting = () => {
  const title = 'O2E Digital Journey - Book Meeting'; 
  const [searchText, setSearchText] = useState(''); 
  const { transcript, listening, resetTranscript } = useSpeechRecognition(); 

  useEffect(() => {
    document.title = title;
  }, [title]);
  
  useEffect(() => {
    if (!listening && transcript) {
      setSearchText(transcript);
      resetTranscript();
    }
  }, [listening, transcript, resetTranscript]);

  const handleMicClick = () => {
    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      resetTranscript();
        SpeechRecognition.startListening({ language: "en-IN" });
    }
  };
  const handleClear = () => {
    setSearchText('')
  }

  return (
    <section className='section-block'>
      <div className='section-header'>
        <Link to="/oppurtunity-list">
          <img src="./image/icons/back.svg" alt='Back to Page' />
        </Link>
        <h1>Book Meeting</h1>
      </div>
      <div className='book-meeting'>        
        <div className='meeting-form'>
          <div className='meeting-speech-text'>
                      <input className="form-control" type='text' onChange={(e) => setSearchText(e.target.value)} value={searchText ? searchText : ''} placeholder='Schedule Meeting'/>
            {searchText &&  <div className='clear-btn' onClick={handleClear}><MdClear /></div>}           
            <button
              className='btn btn-lg'
              onClick={handleMicClick}
            > 
              {listening ? <FaMicrophoneAltSlash /> : <FaMicrophoneAlt />}
            </button>  
          </div>
          <button type='submit' className='btn btn-lg btn-success'>Schedule Meeting</button>
        </div>
      </div>
    </section>
  );
};

export default BookMeeting;
